/**
 * The root slice's name, in a module of its own so that it imports nothing.
 *
 * rootReducer.js and rootThunks.js import each other, and rootThunks.js reads this while it
 * is still loading: every thunk's action type is built at module level. When it was declared
 * in rootReducer.js, loading rootReducer.js first meant reading a `const` before its
 * initialisation. In the old ES5 bundle that could only ever be a silent `undefined`; the Vite
 * dev server, which loads native modules, crashed on it before the CMS rendered.
 * rootReducer.js re-exports it, so nothing that imports it from there has to change.
 */
export const reducerName = 'root';
